import React, { useState, useContext } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { EnvContext } from '../App';
import { AuthContext } from '../security/AuthProvider';

function ImpersonatePage() {
    const envProvider = useContext(EnvContext);
    const authProvider = useContext(AuthContext);
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [result, setResult] = useState(null);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);

    const handleImpersonate = async (e) => {
        e.preventDefault();
        setResult(null);
        setError(null);
        setLoading(true);
        try {
            const apiBase = envProvider.v2Api;
            const response = await axios.post(
                `${apiBase}/v1/users/impersonate`,
                email,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'jm-client': `web-${process.env.REACT_APP_VERSION}`,
                    },
                }
            );
            
            // Store the impersonation token and start impersonating
            const impersonationToken = response.data;
            authProvider.startImpersonation(impersonationToken, email);
            
            // Show success message and redirect
            setResult(`Successfully impersonating ${email}`);
            setTimeout(() => {
                navigate('/time-entry');
            }, 1500);
            
        } catch (err) {
            if (err.response) {
                setError(err.response.data);
            } else {
                setError(err.message || 'Unknown error');
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-full flex items-center justify-center px-4 sm:px-6 lg:px-8">
            <div className="max-w-md w-full space-y-8">
                <h2 className="mt-6 text-center text-3xl tracking-tight font-bold text-gray-900">
                    Impersonate User
                </h2>
                <form className="mt-8 space-y-6" onSubmit={handleImpersonate}>
                    <div>
                        <label htmlFor="impersonate-email" className="block text-sm font-medium text-gray-700">Impersonate Email</label>
                        <input
                            id="impersonate-email"
                            name="impersonate-email"
                            type="email"
                            autoComplete="email"
                            required
                            className="appearance-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:ring-primary-500 focus:border-primary-500 focus:z-10 sm:text-sm mt-2"
                            value={email}
                            onChange={e => setEmail(e.target.value)}
                        />
                    </div>
                    <div>
                        <button
                            type="submit"
                            className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-primary-600 hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500"
                            disabled={loading}
                        >
                            {loading ? 'Impersonating...' : 'Impersonate'}
                        </button>
                    </div>
                </form>
                {result && (
                    <div className="text-center text-green-600 font-semibold mt-2 break-all">{result}</div>
                )}
                {error && (
                    <div className="text-center text-red-500 font-semibold mt-2">{error}</div>
                )}
            </div>
        </div>
    );
}

export default ImpersonatePage; 